export default __webpack_public_path__ + "static/media/background-3.5fa57826.jpg";